import { Inventory } from "@1games-ru/region-shared/dist/types/inventory/inventory";

export default function createFakeInventory(data: Partial<Inventory>): Inventory {
  const fake: Inventory = {
    id: 1,
    ownerType: "fakeOwnerType",
    ownerId: "fakeOwnerId",
    weight: 10,
    maxWeight: 100,
    items: [],
    size: { width: 1, height: 1 },
    ...data,
  };
  return fake;
}
